module.exports = __webpack_public_path__ + "static/media/hse.7fc1bcaf.jpg";